export interface IPhoneNumber {
  areaCode: string;
  nbr: string;
}
